import {modalCommentLink} from "./hoc/modalCommentLink";

const WaybillV2ResponsiblePersonTillReturn = modalCommentLink("WaybillV2ResponsiblePersonTillReturn")

export default WaybillV2ResponsiblePersonTillReturn
